import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import FollowersContainer from "@/views/follow/FollowersContainer.vue";
import PostsContainer from "@/views/like/PostsContainer.vue";
// import MoreContainer from "@/views/more/MoreContainer.vue";
import CoinsContainer from "@/views/coinStore/CoinsContainer.vue";
import EarnCoinContainer from "@/views/earnCoins/earnCoin/EarnCoin.vue";
import Splash from "@/views/splash/Splash.vue";
import PaymentContainer from "@/views/payment/Payment.vue";
import SuperPayLaunch from "@/views/superPay/superPayLaunch/SuperPayLaunch.vue";
// import VipCenterContainer from "@/views/vipCenter/VipCenter.vue";

//====================== async component =========================

const MoreContainer = () => import("@/views/more/MoreContainer.vue");
const LoginContainer = () =>
  import("@/views/login/loginContainer/LoginContainer.vue");
const VipCenterContainer = () => import("@/views/vipCenter/VipCenter.vue");
const VipCenterPagePlanB = () =>
  import("@/views/vipPlanB/VipCenterPagePlanB.vue");
const VipRetainPagePlanB = () =>
  import("@/views/vipPlanB/VipRetainPagePlanB.vue");
const CoinsStore = () => import("@/views/coinStore/CoinsStore.vue");
const SubsFollowerContainer = () =>
  import("@/views/subs/subsFollower/SubsFollower.vue");
const SubsLikesContainer = () => import("@/views/subs/subsLike/SubsLike.vue");
const DoubleCoinSplashContainer = () =>
  import("@/views/coinStore/DoubleCoinSplash/DoubleCoinSplash.vue");
const HalfCoinsSplashContainer = () =>
  import("@/views/coinStore/HalfCoinsSplash/HalfCoinsSplash.vue");
const TurboModeContainer = () => import("@/views/turboMode/TurboMode.vue");
const OrderContainer = () => import("@/views/orders/Order.vue");
const ChallengeRequire = () =>
  import("@/views/login/challengeRequire/ChallengeRequire.vue");
const SecurityCodeContainer = () =>
  import("@/views/login/securityCode/SecurityCode.vue");
const OrderDetailContainer = () =>
  import("@/views/orderDetail/OrderDetail.vue");
const AccountManageContainer = () =>
  import("@/views/accountManage/accountManage.vue");
const AccountBindContainer = () =>
  import("@/views/accountManage/accountBind.vue");
const SearchUserContainer = () => import("@/views/searchUser/SearchUser.vue");
const LoginSelectContainer = () =>
  import("@/views/login/loginSelect/LoginSelect.vue");
const SettingsContainer = () => import("../views/settings/Settings.vue");
const SettingPrivacyContainer = () =>
  import("@/views/settings/SettingPrivacy.vue");
const SettingTermContainer = () => import("@/views/settings/SettingTerm.vue");
const VipDiscountContainer = () => import("@/views/coinStore/VIPDiscount.vue");
const PushSettingsContainer = () =>
  import("@/views/settings/pushSettings/PushSettings.vue");
const CompleteProfileContainer = () =>
  import("@/views/completeProfile/CompleteProfile.vue");
const testCompleteProfile = () =>
  import("@/views/completeProfile/testCompleteProfile.vue");
const Stripe = () => import("@/views/stripe/stripe.vue");
const CasinoContainer = () => import("@/views/casino/CasinoContainer.vue");
const FaqContainer = () => import("@/views/faqs/faqs.vue");
const SubsOrderList = () =>
  import("@/views/subs/subsOrderList/subsOrderList.vue");
const SubsOrderDetail = () =>
  import("@/views/subs/subsOrderList/subsOrderDetail.vue");
const SuperPayAddition = () =>
  import("@/views/superPay/superPayAddition/SuperPayAddition.vue");
const TestView = () => import("@/views/testView/TestView.vue");

Vue.use(Router);
/**
 * 1.主页面>Home:[Followers,Likes,Earn Coins,Buy Coins,More] 5个Tabs页面
 * 2.子页面>
 */

const RouterInstance: any = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/Home"
    },
    {
      path: "/Splash",
      name: "Splash",
      component: Splash
    },
    {
      path: "/Home",
      name: "Home",
      component: Home,
      children: [
        {
          path: "Followers/:comeFromNotice",
          name: "Followers",
          component: FollowersContainer
        },
        {
          path: "Posts/:comeFromNotice",
          name: "Posts",
          component: PostsContainer
        },
        {
          path: "EarnCoin",
          name: "EarnCoin",
          component: EarnCoinContainer
        },
        {
          path: "CoinsContainer",
          name: "CoinsContainer",
          component: CoinsContainer
        },
        {
          path: "More",
          name: "More",
          component: MoreContainer
        }
      ]
    },
    {
      path: "/LoginSelect",
      name: "LoginSelect",
      component: LoginSelectContainer
    },
    {
      path: "/Login",
      name: "Login",
      component: LoginContainer
    },
    {
      path: "/Login/ChallengeRequire",
      name: "ChallengeRequire",
      component: ChallengeRequire
    },
    {
      path: "/Login/ChallengeRequire/SecurityCode",
      name: "SecurityCode",
      component: SecurityCodeContainer
    },
    {
      path: "/DoubleCoinSplash",
      name: "DoubleCoinSplash",
      component: DoubleCoinSplashContainer
    },
    {
      path: "/HalfCoinsSplash",
      name: "HalfCoinsSplash",
      component: HalfCoinsSplashContainer
    },
    {
      path: "/VIPDiscount",
      name: "VIPDiscount",
      component: VipDiscountContainer
    },
    {
      path: "/SubsFollower",
      name: "SubsFollower",
      component: SubsFollowerContainer
    },
    {
      path: "/SubsLikes",
      name: "SubsLikes",
      component: SubsLikesContainer
    },
    {
      path: "/Order",
      name: "Order",
      component: OrderContainer
    },
    {
      path: "/SubsOrderList/:routerTransition?",
      name: "SubsOrderList",
      component: SubsOrderList
    },
    {
      path: "/SubsOrderDetail",
      name: "SubsOrderDetail",
      component: SubsOrderDetail
    },
    {
      path: "/Settings",
      name: "Settings",
      component: SettingsContainer
    },
    {
      path: "/Settings/PushSettings",
      name: "PushSettings",
      component: PushSettingsContainer
    },
    {
      path: "/SettingPrivacy",
      name: "SettingPrivacy",
      component: SettingPrivacyContainer
    },
    {
      path: "/SettingTerm",
      name: "SettingTerm",
      component: SettingTermContainer
    },
    {
      path: "/Payment",
      name: "Payment",
      component: PaymentContainer
    },
    {
      path: "/OrderDetail/:result",
      name: "OrderDetail",
      component: OrderDetailContainer
    },
    {
      path: "/AccountManage",
      name: "AccountManage",
      component: AccountManageContainer
    },
    {
      path: "/AccountBind",
      name: "AccountBind",
      component: AccountBindContainer
    },
    {
      path: "/TurboMode",
      name: "TurboMode",
      component: TurboModeContainer
    },
    {
      path: "/VipCenter",
      name: "VipCenter",
      component: VipCenterContainer
    },
    {
      path: "/VipCenterPlanB",
      name: "VipCenterPlanB",
      component: VipCenterPagePlanB
    },
    {
      path: "/VipRetainPlanB",
      name: "VipRetainPlanB",
      component: VipRetainPagePlanB
    },
    {
      path: "/SearchUser",
      name: "SearchUser",
      component: SearchUserContainer
    },
    {
      path: "/CompleteProfile",
      name: "CompleteProfile",
      component: CompleteProfileContainer
    },
    {
      path: "/testCompleteProfile",
      name: "testCompleteProfile",
      component: testCompleteProfile
    },
    {
      path: "/Stripe",
      name: "Stripe",
      component: Stripe
    },
    {
      path: "/Casino",
      name: "Casino",
      component: CasinoContainer
    },
    {
      path: "/ConinsStore",
      name: "CoinsStore",
      component: CoinsStore
    },
    {
      path: "/faqs",
      name: "faqs",
      component: FaqContainer
    },
    {
      path: "/SuperPayAddition",
      name: "SuperPayAddition",
      component: SuperPayAddition
    },
    {
      path: "/SuperPayLaunch",
      name: "SuperPayLaunch",
      component: SuperPayLaunch
    },
    {
      path: "/TestView",
      name: "TestView",
      component: TestView
    }
  ]
});

export default RouterInstance;
